// read https://medium.com/simply/state-management-with-react-hooks-and-context-api-at-10-lines-of-code-baf6be8302c
import React, { createContext, useContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { useReactContextDevTool } from 'hooks'

export const AppContext = createContext();

// initial state
const initState = {
  isGlobalNavOpen: false,
  modalsOpen: [],
  shouldCloseModalOnClickOutside: true,
};

// actions
export const actions = {
  NAV_GLOBAL_OPEN_UPDATE: 'NAV_GLOBAL_OPEN_UPDATE',
  MODAL_ADD: 'MODAL_ADD',
  MODAL_REMOVE: 'MODAL_REMOVE',
  MODAL_SET_SHOULD_CLOSE_ON_CLICK_OUTSIDE: 'MODAL_SHOULD_CLOSE_ON_CLICK_OUTSIDE',
};

// reducer
const reducer = (state, action) => {
  const { type, data } = action;

  switch (type) {
  case actions.NAV_GLOBAL_OPEN_UPDATE:
    return {
      ...state,
      isGlobalNavOpen: data,
    };
  case actions.MODAL_ADD:
    return {
      ...state,
      modalsOpen: [...state.modalsOpen, data],
    };
  case actions.MODAL_REMOVE: {
    const { modalsOpen } = state
    const indexToRemove = modalsOpen.indexOf(data)
    if (indexToRemove !== -1) {
      const result = Array.from(modalsOpen)
      // remove element from array
      result.splice(indexToRemove, 1);
      return {
        ...state,
        modalsOpen: result,
      };
    }
    return state
  }
  case actions.MODAL_SET_SHOULD_CLOSE_ON_CLICK_OUTSIDE:
    return {
      ...state,
      shouldCloseModalOnClickOutside: data,
    };
  default:
    return state;
  }
};

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initState)
  useReactContextDevTool({ id: 'app', displayName: 'App', values: state })

  return (
    <AppContext.Provider value={[state, dispatch]}>
      {children}
    </AppContext.Provider>
  );
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAppContext = () => useContext(AppContext);
